import { useEffect } from 'react';

export const BASE_TITLE = 'Tower Title';

/**
 * Sets the browser tab title while the calling page is mounted and restores the
 * base title on unmount. Pass a falsy value to skip updating (useful while a
 * dynamic detail such as an order number is still loading).
 *
 * @param {string} title - The page-specific title, e.g. 'Order TT-1024'.
 */
const useDocumentTitle = (title) => {
  useEffect(() => {
    if (!title) return undefined;

    document.title = `${title} | ${BASE_TITLE}`;

    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
};

export default useDocumentTitle;
